import { Component, Output, Input, EventEmitter, SimpleChanges, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { HttpClient } from '@angular/common/http';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { AgentscriptService_updated } from 'src/app/services/agent-script-service/agent-script-service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-grid-view-sr',
  templateUrl: './grid-view-sr.component.html',
  styleUrls: ['./grid-view-sr.component.scss']
})
export class GridViewSrComponent {
  @Output() serviceTypeDetailsOutputEvent = new EventEmitter();
  @Input() serviceTypeInfo: any;
  @Output() dataInformation=new EventEmitter();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  serviceTypeSearch: any = '';
  selectedServiceType: any = {};
  selectedDepartmentTypes: any = {};
  searchService: any;
  departmentItems: any = [];
  caseTypeVal: any = [];
  // dataSource: MatTableDataSource<any>;
  displayedColumnsGrid: string[] = ['id', 'content', 'actions'];
  newcaseTypeVal : any;
  filterboxes: any;
  tab_title:any
  commonitems: any

  applyfiltersfromservice()
  {
    if(this.agentscriptService.fetchData(this.tab_title,'searchterms')!=0)
    {

      setTimeout(() => {
        $('.dataTables_filter input').val(this.searchterms).keyup();

      }, 1000);
      this.searchterms=this.agentscriptService.fetchData(this.tab_title,'searchterms')
      this.applyFilter()
      // $('.pane:visible .dataTables_filter input').val(this.searchterms).trigger('keyup');
    }
    if(this.agentscriptService.fetchData(this.tab_title,'filteredvalue')!=0)
    {
      console.log(this.agentscriptService.fetchData(this.tab_title,'filteredvalue'))

      setTimeout(() => {
        // alert(this.agentscriptservice.fetchData(this.tab_title,'filteredvalue')+'-'+this.tab_title)
        // alert($('#filteredtag-' + this.agentscriptservice.fetchData(this.tab_title,'filteredvalue')+'-'+this.tab_title).attr('data-filter-id'))
        // alert($('#filteredtag-' + this.agentscriptservice.fetchData(this.tab_title,'filteredvalue')+'-'+this.tab_title).length )
          $('#filteredtag-' + this.agentscriptService.fetchData(this.tab_title,'filteredvalue')+'-'+this.tab_title).trigger('click')
 
      }, 1000);
  }
   
  }


  ngOnInit() {
    this.dataInformation.emit();

    this.tab_title = $(".custom-tabs li.active").find("a").attr('data-obj-title')
    // this.http.get<any>('/assets/json/dataArray.json').subscribe((data) => {
      this.http.get<any>(environment.apiURL + 'getDeptcasedefToAgent').subscribe((data) => {
      this.departmentItems = data;
      this.departmentItems.forEach(obj => {
        obj.caseType.forEach(ele => {
          this.caseTypeVal.push(ele);
        });
      })
      this.caseTypeVal.sort((a: { content: string; }, b: { content: string; }) => {
        const contentA = a.content.toLowerCase();
        const contentB = b.content.toLowerCase();
    
        if (contentA < contentB) return -1;
        if (contentA > contentB) return 1;
        return 0;
    });

    this.caseTypeVal?.forEach(datarray => {
      datarray.isfavourite = 'false';
    });

    this.departmentDataSource = this.caseTypeVal
      this.casetypeDataSource = this.caseTypeVal

      this.getfavourites();

      console.log(this.casetypeDataSource)
      this.newcaseTypeVal=this.caseTypeVal.filter((x:any)=>x?.filteringvalues?.includes('Recents'))

      // this.casetypeDataSource.filteredData?.forEach(datarray => {
      //   datarray.isfavourite = 'false';
      // });
      // if (this.serviceTypeInfo && this.serviceTypeInfo.serviceDetails && this.serviceTypeInfo.serviceDetails.caseType || this.serviceTypeInfo  && this.serviceTypeInfo.caseType) {
      //   this.selectedDepartmentTypes = this.serviceTypeInfo?this.serviceTypeInfo:this.serviceTypeInfo;
      //   if(this.serviceTypeInfo){
      //     let serviceDetails = {
      //       serviceDetails:this.serviceTypeInfo.serviceDetails
      //     }
      //     this.serviceTypeInfo = serviceDetails;
      //   }
      //   this.getCaseType(this.serviceTypeInfo.serviceDetails)
      // }else if(this.departmentItems && this.departmentItems.length){
      // }
      this.applyfiltersfromservice();
    });


    this.http.get<any>('/assets/json/filter_tags.json').subscribe((data) => {
      this.filterboxes = data[0].filter;
      console.log(data)
      console.log(this.filterboxes)
    });

    // this.newcaseTypeVal = this.caseTypeVal;
    console.log(this.caseTypeVal)
    // console.log(this.casetypeDataSource.filteredData)
  }
  // ngOnChanges(changes: SimpleChanges) {
  //   this.setListView();
  // }

  // setListView() {
  //   if (this.selectedDepartmentTypes && this.selectedDepartmentTypes.caseType) {
  //     this.dataSource = new MatTableDataSource(this.selectedDepartmentTypes.caseType);
  //   } else {
  //     this.dataSource = new MatTableDataSource([]);
  //   }
  //   setTimeout(() => {
  //     this.dataSource.paginator = this.paginator;
  //     this.dataSource.sort = this.sort;
  //   })

  // }

  clearsearch()
  {
    this.searchterms=""
    this.agentscriptService.updateOrInsertArray(this.tab_title,'searchterms','')
    this.caseTypeVal=this.casetypeDataSource
  }

  getidbycasetypedepartment(arrayItem: any) {
    // console.log(arrayItem)
    // console.log(this.commonitems)
    // console.log((casesubtypeid !== "" && this.favouritesarray[0].hasOwnProperty('casesubtypeid')) ? this.favouritesarray[0].casesubtypeid == casesubtypeid : true)
    // console.log(casetypeid,departmentid,casesubtypeid)
    // console.log(this.favouritesarray)
    // const item =this.favouritesarray.find(item => { return item.casetypeid == casetypeid && item.departmentid == departmentid });
    // console.log(((casesubtypeid !== "" && this.favouritesarray[0].hasOwnProperty('casesubtypeid') && this.favouritesarray[0].casesubtypeid!=null) ? this.favouritesarray[0].casesubtypeid == casesubtypeid : true))

    // console.log(this.commonitems)

    // if (this.commonitems?.includes(arrayItem)) {
    //   arrayItem.isfavourite='true'
    //   return true
    // }
    // else{
    //   arrayItem.isfavourite='false'
    //   // this.datatablepagination();
    //   return false;
    // }

    arrayItem.isfavourite = 'false'
    this.commonitems?.forEach((item:any)=>
    {
      if(item.casetypeid == arrayItem.casetypeid && item.division.id == arrayItem.division.id && (((item.casesubtypeid!=null && arrayItem.casesubtypeid!=null)?item.casesubtypeid == arrayItem.casesubtypeid:true)))
        {
          arrayItem.isfavourite = 'true'
        }
    })


  }

  favouritesarray: any
  getfavourites() {

    this.agentscriptService.getMyFavourites().subscribe((data)=>{

      this.favouritesarray = data;
      console.log(data)

      
      if (this.favouritesarray && this.favouritesarray.length > 0) 
      {
        this.commonitems = this.caseTypeVal.filter(item1 =>
          this.favouritesarray?.some(item2 => item1.casetypeid == item2.casetypeid && item1.department.id == item2.departmentid)
        );
      }
      else{
        this.commonitems=[]
      }
      
      this.agentscriptService.commonitems=this.commonitems

      console.log(this.commonitems)
    })

  }
  getIdbasedarrayItem(itemarray:any) {

    const item =this.favouritesarray.find(item => item.casetypeid == itemarray.casetypeid && item.departmentid == itemarray.department.id );

    if(item)
    {
      return item.starredid
    }
    else{
      return 0
    }

  }

  togglefavourite(item: any, index: any, favourite: any) {

    console.log(item, index, favourite)
    var formdata: any
    if (favourite == true) {
      // alert("true")
      delete item.isfavourite;
      item.isfavourite = 'true';
      formdata = {
        "casetype": item.casetypeid,
        "department": item.department.id,
        "isfav": favourite
      }
      this.caseTypeVal[index].isfavourite='true'
    }
    else {
      // alert("false")
      delete item.isfavourite;
      item.isfavourite = 'false';
      item.test=false
      formdata = {
        "casetype": item.casetypeid,
        "department": item.department.id,
        "casesubtype": item?.casesubtypeid,
        "isfav": favourite,
        "id": this.getIdbasedarrayItem(item)
      }
      console.log(item)
      this.caseTypeVal[index].isfavourite='false' 
      console.log(this.caseTypeVal)
      if ($("[data-filter-id*='favourite']")?.attr('class')?.includes('activetab')) 
        {
        this.caseTypeVal.splice(index, 1)
      }
    }

    console.log(formdata)

    this.http.post(environment.apiURL + 'updateStarred', formdata).subscribe((data: any) => {
      console.log(data)


      // this.caseTypeVal[index]={"casetypeid":item.casetypeid}

      // var casetypevalues=this.caseTypeVal
      //   this.caseTypeVal=[]
      // setTimeout(() => {
      // this.caseTypeVal[index].casetypeid=data.casetypepicklist.id
      // this.caseTypeVal[index].department.id=data.departmentpicklist.id
      // Object.keys(this.caseTypeVal).forEach(key => delete this.caseTypeVal[key]);
      // this.caseTypeVal=[]
      // this.caseTypeVal[index].casesubtypeid
      // this.caseTypeVal=casetypevalues
      // this.datatablepagination()
      // }, 100)
      // this.caseTypeVal[index]=item
      console.log(item)
      console.log(this.caseTypeVal)
      this.getfavourites();
      // this.cdr.detectChanges();
      // this.cdr.detectChanges();
      // this.cdr.markForCheck();
      // this.cdr.detectChanges();
    })
  }

  myfavouritesfilter() {
    this.caseTypeVal = this.casetypeDataSource

    this.commonitems = this.caseTypeVal.filter(item1 =>
      this.favouritesarray?.some(item2 => item1.casetypeid == item2.casetypeid && item1.department.id == item2.departmentid)
    );

    this.caseTypeVal = this.commonitems
  }


  triggerfavouritesfunction()
  {
    // alert()
    if($("[data-filter-id='" + this.tab_title+'-favourites'+"']").hasClass('activetab'))
      {
        // alert($('#filteredtag-favourites-'+this.tab_title).length)
        $('#filteredtag-favourites-'+this.tab_title).trigger('click')
      }
  }

  
  filter(data: any) {
    this.agentscriptService.updateOrInsertArray(this.tab_title,'searchterms','')
    this.agentscriptService.updateOrInsertArray(this.tab_title,'filteredvalue',data)

    console.log(data)
    if (data.toLowerCase().includes('favourite')) {

      this.agentscriptService.getMyFavourites().subscribe((data)=>{

        this.favouritesarray = data;
        console.log(data)
  
        this.caseTypeVal = this.casetypeDataSource;
        this.commonitems = this.caseTypeVal.filter(item1 =>
          this.favouritesarray?.some(item2 => item1.casetypeid == item2.casetypeid && item1.department.id == item2.departmentid)
        );
  
        console.log(this.commonitems)

        this.caseTypeVal=this.commonitems
      })
      // this.myfavouritesfilter()

      // $("[data-filter-id='" + this.tab_title+'-'+data + "']").attr('data-filter-close', 'close')

      // $("[data-filter-id]").not("[data-filter-id='" + this.tab_title+'-'+data + "']").attr('data-filter-close', 'open');

    }
    else if (data.toLowerCase().includes('recent')) {
      this.caseTypeVal = this.casetypeDataSource
      this.agentscriptService.getRecents().subscribe((data) => {
        console.log(data)

        var newdata: any = []
        newdata = data
        var filteringarray;
        filteringarray = this.caseTypeVal.filter(item1 =>
          newdata.some(item2 => item1.casetypeid == item2.casetypeid && item1.department.id == item2.departmentid)
        );


        console.log(filteringarray)
        this.caseTypeVal = filteringarray
      })
      }
    else{
      console.log(this.caseTypeVal)
      this.agentscriptService.getfilterbyseason(data).subscribe((data) => {
        console.log(data)

        var newdata:any=[]
        newdata=data
        this.caseTypeVal = this.casetypeDataSource;

        var filteredarray:any
        filteredarray = this.caseTypeVal.filter(item1 =>
          newdata.some(item2 => item1.casetypeid == item2.casetypeid && item1.department.id == item2.departmentid)
        );

        
      console.log(filteredarray)
      this.caseTypeVal=filteredarray
      })

    // this.caseTypeVal = [...this.casetypeDataSource].filter((x: any) =>
    // {
    //   return x.filteringvalues && x.filteringvalues.some((value: string) =>
    //   value.toLowerCase().includes(data.toLowerCase())
    // );
    // })

    }

    $(".pane:visible [data-filter-id]").removeClass('activetab');
    $(".pane:visible  [data-filter-id='" + this.tab_title+'-'+data + "']").addClass('activetab');
    
    this.newarray=this.caseTypeVal
    
  }
  newarray:any
  displayclose(item:any)
  {
    return $("[data-filter-id='" + this.tab_title+'-'+item + "']").attr('class').includes('activetab')

    // return $("[data-filter-id='" + this.tab_title+'-'+item+ "']").attr('data-filter-close')
  }
  closefilter(data:any) {

    this.agentscriptService.getMyFavourites().subscribe((data) => {
      console.log(data)
      this.favouritesarray = data;
      if (this.favouritesarray && this.favouritesarray.length > 0) {
      this.commonitems = this.caseTypeVal.filter(item1 =>
        this.favouritesarray?.some(item2 => item1.casetypeid == item2.casetypeid && item1.department.id == item2.departmentid)
      );
    }
    else{
      this.commonitems=[]
    }
    
    this.agentscriptService.commonitems=this.commonitems
      console.log(this.commonitems)
      
    })
    this.agentscriptService.updateOrInsertArray(this.tab_title,'filteredvalue',[])

    this.caseTypeVal = this.casetypeDataSource;
    
    $(".pane:visible [data-filter-id]").removeClass('activetab');

    // $("[data-filter-id='" + this.tab_title+'-'+data+ "']").attr('data-filter-close', 'open')
  }
  gotoNext(data: any) {
    console.log(data.serviceDetails)
    this.agentscriptService.addtorecentservices(data.serviceDetails).subscribe((response)=>
      {
        console.log(response)
      })
    // this.agentscriptService.updateOrInsertArray(this.tab_title,'casetypedata',data.serviceDetails)
    // console.log(this.agentscriptService.fetchData(this.tab_title,'casetypedata'))
    console.log(data)
    this.agentscriptService.updateOrInsertArray(this.tab_title, 'modifiedfromanonymouscontact',0)

    // let serviceDetails = data.serviceDetails;
    // this.selectedServiceType["serviceDetails"] = serviceDetails;
    // this.selectedDepartmentTypes = serviceDetails;
    // data.serviceDetails['caseType'] = this.casetypeDataSource.filteredData;
    this.serviceTypeDetailsOutputEvent.emit(data)
  }
  displayedColumns: string[] = ['id', 'content', 'actions'];
  caseTypeCard: Boolean = false;
  departmentDataSource = new MatTableDataSource(this.departmentItems);
  casetypeDataSource :any
  constructor(private agentscriptService:AgentscriptService_updated,private http: HttpClient) { }
  getCaseType(item: any) {
    this.selectedServiceType = item;
    this.selectedDepartmentTypes = item;
    this.serviceTypeSearch = "";
    this.caseTypeCard = true;
    this.casetypeDataSource = (item.caseType.length) ? new MatTableDataSource(item.caseType) : new MatTableDataSource(this.departmentItems.caseType);
    // this.setListView();
  }

  searchterms = '';
  applyFilter() {
    $(".pane:visible [data-filter-id]").removeClass('activetab');

    console.log(this.searchterms)
    console.log(this.casetypeDataSource)
    console.log(this.caseTypeVal)
    // this.caseTypeVal=this.casetypeDataSource

    this.caseTypeVal = [...this.casetypeDataSource].filter((x: any) => {
      return x.content.toLowerCase().includes(this.searchterms) || x.department.name.toLowerCase().includes(this.searchterms) || x.division.name.toLowerCase().includes(this.searchterms)
    });
      console.log(this.caseTypeVal)
    this.agentscriptService.updateOrInsertArray(this.tab_title,'searchterms',this.searchterms.toLowerCase())
    this.agentscriptService.updateOrInsertArray(this.tab_title,'filteredvalue','')

    $("[data-filter-close]").attr('data-filter-close', 'open');


    // console.log(this.caseTypeVal)
    // console.log(this.searchterms)

    // this.newcaseTypeVal = [...this.caseTypeVal].filter((x: any) =>
    //   x.content.toLowerCase().includes(this.searchterms)
    // )

    
  }

  onSelect(item: any) {
    this.searchterms = item.content

    this.departmentDataSource = item.content.trim().toLowerCase();
    this.casetypeDataSource = item.content.trim().toLowerCase();
  }

  back() {
    this.caseTypeCard = false;
  }
  // onEnter(event: any) {
  //   const filterValue = event.option.value;
  //   this.departmentDataSource = filterValue.trim().toLowerCase();
  //   this.casetypeDataSource = filterValue.trim().toLowerCase();
  // }
  // onDeptEnter(event: any) {
  //   const filterValue = event.option.value;
  //   this.departmentDataSource.filter = filterValue.trim().toLowerCase();
  //   this.casetypeDataSource.filter = filterValue.trim().toLowerCase();
  // }

  togglefavourites(item:any){
console.log(item);
item.stopPropagation();
  }

}